/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { IdentifyFeatureDto } from '../../models/identify-feature-dto';

export interface GetFeatureById$Params {
  featureId: number;
}

export function getFeatureById(
  http: HttpClient,
  rootUrl: string,
  params: GetFeatureById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<IdentifyFeatureDto>> {
  const rb = new RequestBuilder(rootUrl, getFeatureById.PATH, 'get');
  if (params) {
    rb.path('featureId', params.featureId, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IdentifyFeatureDto>;
      }),
    );
}

getFeatureById.PATH = '/features/{featureId}';
